import { TalentExclusivity } from "../../talents/talentAPI";
import {
  CreateExclusivityEntry,
  UpdateExclusivityEntry,
} from "../../talents/types/commands";
import { ExclusivityFormValues } from "./AddExclusivityForm";

export const defaultExclusivityFormValues: ExclusivityFormValues = {
  customerCompany: null,
  customerOrganization: null,
  workLocation: null,
  workTitles: [],
};

export const mapEntryToExclusivityFormValues = (
  entry: TalentExclusivity,
): ExclusivityFormValues => ({
  customerCompany: {
    id: entry.customerCompanyId,
    name: entry.customerCompanyName,
  },
  customerOrganization:
    entry.customerOrganizationId && entry.customerOrganizationName
      ? { id: entry.customerOrganizationId, name: entry.customerOrganizationName }
      : null,
  workLocation:
    entry.workLocationId && entry.workLocationName
      ? { id: entry.workLocationId, name: entry.workLocationName }
      : null,
  workTitles: entry.workTitles.map((wt) => ({ id: wt.id, name: wt.name })),
});

export const mapFormToCreateExclusivityPayload = (
  formData: ExclusivityFormValues,
  talentId: string,
): CreateExclusivityEntry => ({
  talentId,
  customerCompanyId: formData.customerCompany!.id,
  customerOrganizationId: formData.customerOrganization?.id,
  workLocationId: formData.workLocation?.id,
  workTitleIds: formData.workTitles.map((wt) => wt.id),
});

export const mapFormToUpdateExclusivityPayload = (
  formData: ExclusivityFormValues,
  entry: TalentExclusivity,
): UpdateExclusivityEntry => ({
  exclusivityEntryId: entry.id,
  customerOrganizationId: formData.customerOrganization?.id,
  workLocationId: formData.workLocation?.id,
  workTitleIds: formData.workTitles.map((wt) => wt.id),
  version: entry.version,
});
